/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Arrow from 'components/Icons/Arrow/Arrow';
import useScrolled from 'utils/scrolled';
import scrollTo from 'utils/scrollTo';
import './StickyScrollHint.scss';

/**
 * This is the StickyScrollHint component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function StickyScrollHint({ title, target, alignTop, ...props }) {
  const active = useScrolled(50);

  function onClick() {
    if (target === null) {
      scrollTo(window, alignTop);
    } else {
      const targetElement = document.querySelector(target);
      if (targetElement) {
        scrollTo(targetElement, alignTop);
      }
    }
  }

  return (
    <button
      className={classnames('hint sticky-scroll-hint', { active })}
      onClick={onClick}
    >
      <Arrow {...props} title={title} />
    </button>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
StickyScrollHint.propTypes = {
  title: PropTypes.string.isRequired,
  target: PropTypes.string,
  alignTop: PropTypes.bool,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
StickyScrollHint.defaultProps = {
  title: null,
  target: null,
  alignTop: false,
};

export default StickyScrollHint;
